/**
 * API 基础地址
 * 本地开发：走 Vite 代理 /api → https://www.aiiifly.com（避免浏览器跨域）
 * 生产构建：直连线上 API（可通过 .env.production 覆盖）
 */
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.DEV ? '/api' : 'https://www.aiiifly.com/api')

/** 代理目标（仅 vite.config 使用，与线上域名保持一致） */
export const API_PROXY_TARGET =
  import.meta.env.VITE_API_PROXY_TARGET || 'https://www.aiiifly.com'
